import React from 'react';
import '../Register.css';


function Register() {
    return (
        <div className="dflex jc-center">
            <div className="w74">
                <div className="register-container dflex ai-center jc-center">
                    <input type="text" placeholder="Profile" id="profileinput" />
                    <input type="text" placeholder="Password" id="passwordinput" />
                    <button>Sign In</button>
                </div>
            </div>
        </div>
    );
};

export default Register;